import { palette } from "@plantura-garden/palette";

const Checkmark = ({ color }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill={color || palette.green900} />
      <path
        d="M15.8332 8.16634L10.3332 15.833L8.1665 13.6663"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { Checkmark };
